var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.646,
    height: 19.439,
    viewBox: "0 0 17.646 19.439",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.75 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.294,6H18.852a1.794,1.794,0,0,1,1.794,1.794V20.352a1.794,1.794,0,0,1-1.794,1.794H6.294A1.794,1.794,0,0,1,4.5,20.352V7.794A1.794,1.794,0,0,1,6.294,6Z",
    transform: "translate(0 -1.206)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24,3V6.588",
    transform: "translate(-7.839)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12,3V6.588",
    transform: "translate(-3.015)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.5,15H20.646",
    transform: "translate(0 -4.824)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/calender_icon.0e452cf5962828abf813c9402a179ef5.svg";
export { ForwardRef as ReactComponent };